module.exports = __webpack_public_path__ + "static/media/leftmg.4341a0c2.png";